import { render } from "./DriverDashboardVersionItem.vue?vue&type=template&id=261c412b"
import script from "./DriverDashboardVersionItem.vue?vue&type=script&lang=js"
export * from "./DriverDashboardVersionItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__